(function () {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.pp-superform');
  if (!forms.length) return;

  forms.forEach(form => {
    // ------------------ click handling ------------------
    form.addEventListener('click', e => {
      const btn = e.target.closest('button');
      if (!btn) return;

      // Buying option
      if (btn.closest('.buying-option')) {
        activate(btn);
        updateForm(form);
      }

      // Jars
      if (btn.closest('.jars-option')) {
        activate(btn);
        updateForm(form);
      }

      // Frequency
      if (btn.closest('.frequency-option')) {
        activate(btn);
        updateForm(form);
      }

      // Add to cart
      if (btn.classList.contains('add-to-cart')) {
        e.preventDefault();
        addToCart(form, btn);
      }
    });

    // Init state
    updateForm(form);
  });

  // ---------------- helper functions ----------------
  function activate(btn) {
    const parent = btn.parentElement;
    parent.querySelectorAll('.active').forEach(a => a.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateForm(form) {
    const buyActive = $$('.buying-option .active', form);
    const jarActive = $$('.jars-option .active', form);
    const freqActive = $$('.frequency-option .active', form);

    if (!buyActive || !jarActive) return;

    const isSub = buyActive.dataset.option === 'subscribe';

    // ---------------- update "Each" under Jars ----------------
    const eachEl = jarActive.querySelector('.price-value');
    const perJar = isSub
      ? jarActive.dataset.displayPerjarSub
      : jarActive.dataset.displayPerjarOnetime;
    if (eachEl) eachEl.textContent = `${perJar} each`;

    // ---------------- BUYING OPTION BUTTONS ----------------
    const oneTimeBtn = form.querySelector('.buying-option [data-option="one-time"]');
    const subBtn = form.querySelector('.buying-option [data-option="subscribe"]');

    function updatePriceWrapper(btn, displayPrice, comparePrice) {
      if (!btn) return;

      let wrapper = btn.querySelector('.NewRadioOption__Price');
      if (!wrapper) {
        wrapper = document.createElement('span');
        wrapper.className = 'NewRadioOption__Price';
        btn.appendChild(wrapper);
      }

      wrapper.innerHTML = '';

      if (comparePrice) {
        const compareEl = document.createElement('span');
        compareEl.className = 'NewRadioOption__Price_Compare';
        compareEl.style.textDecoration = 'line-through';
        compareEl.style.fontWeight = '400';
        compareEl.textContent = comparePrice;
        wrapper.appendChild(compareEl);
      }

      const normalEl = document.createElement('span');
      normalEl.className = 'NewRadioOption__Price_Normal';
      normalEl.textContent = displayPrice || '';
      wrapper.appendChild(normalEl);
      if (comparePrice) {
        normalEl.style.color = '#EF4B5B';
      }
    }

    // one-time
    updatePriceWrapper(
      oneTimeBtn,
      jarActive.dataset.displayOnetime,
      jarActive.dataset.displayCompareOnetime
    );

    // subscribe
    updatePriceWrapper(
      subBtn,
      jarActive.dataset.displaySubscribe,
      jarActive.dataset.displayCompareSubscribe
    );

    // ---------------- show/hide frequency section ----------------
    const freqBox = $$('.frequency-option', form);
    const freqHead = $$('.delivery-heading', form);
    if (freqBox) freqBox.style.display = isSub ? 'flex' : 'none';
    if (freqHead) freqHead.style.display = isSub ? 'block' : 'none';
  }

  // ---------------- Add to cart ----------------
  function addToCart(form, btn) {
    const jarActive = $$('.jars-option .active', form);
    const buyActive = $$('.buying-option .active', form);
    const freqActive = $$('.frequency-option .active', form);
    if (!jarActive || !buyActive) return;

    // prevent double click
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    const variantId = jarActive.dataset.variantId;
    const isSub = buyActive.dataset.option === 'subscribe';
    const sellingPlanId = isSub && freqActive ? freqActive.dataset.sellingPlanId : null;

    // ✅ exact variant payload
    const payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
          properties: {
            _SuperformSource: window.location.pathname.includes('/collections/')
              ? 'Collection'
              : 'Product',
            _UniqueForm: form.dataset.unique || 'default'
          }
        }
      ]
    };

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(r => r.json())
      .then(resp => {
        if (resp.status === 422) {
          console.error(resp.message);
          return;
        }

        // 🟢 Refresh CartDrawer (BeyondAlpha logic)
        if (typeof CartDrawer !== 'undefined') {
          if (CartDrawer.update) CartDrawer.update();
          if (CartDrawer.setPreEmpty) CartDrawer.setPreEmpty(false);
          if (CartDrawer.removeAttribute) CartDrawer.removeAttribute('is-empty');
          if (CartDrawer.open) CartDrawer.open();
          console.log('%c🛒 CartDrawer opened via BeyondAlpha superform', 'color:#3db13d');
        } else {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }

        btn.textContent = 'Added!';
        setTimeout(() => (btn.textContent = 'Add to Cart'), 1200);
      })
      .catch(err => console.error('Error adding to cart', err))
      .finally(() => {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  console.log('%c✓ BeyondAlpha superform JS active', 'color:#3db13d');
})();
